import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export function RouteAsClass() {
    const { pathname } = useLocation();
    const className = useMemo(() => pathname.split('/').filter(x => x).map((x, i, all) => all.slice(0, i + 1).join('-').split(' ').join('-') || 'index'), [pathname])

    useEffect(() => {
        document.body.classList.add(...className);
        return () => document.body.classList.remove(...className);
    }, [className])

    return null;
}
